import cellImgae0 from "../images/boards/default/cell0.webp"

import cellImage30 from "../images/boards/default/cell30.webp"
import cellImage10 from "../images/boards/default/cell30.webp"
import cellImage20 from "../images/boards/default/cell20.webp"
import cellImage4 from "../images/boards/default/cell4.webp"
import chanceImage1 from "../images/boards/default/chance1.webp"
import chanceImage2 from "../images/boards/default/chance2.webp"
import chanceImage3 from "../images/boards/default/chance3.webp"
import chanceImage4 from "../images/boards/default/chance4.webp"
import pieceImage1 from "@/images/pieces/piece1.png"
import pieceImage2 from "@/images/pieces/piece2.png"
import pieceImage3 from "@/images/pieces/piece3.png"
import pieceImage4 from "@/images/pieces/piece4.png"
import pieceImage5 from "@/images/pieces/piece5.png"
import pieceImage6 from "@/images/pieces/piece6.png"
import piecePlaceholder1 from "@/images/pieces/placeholder0.png"
import piecePlaceholder2 from "@/images/pieces/placeholder1.png"
import piecePlaceholder3 from "@/images/pieces/placeholder2.png"
import piecePlaceholder4 from "@/images/pieces/placeholder3.png"
import piecePlaceholder5 from "@/images/pieces/placeholder4.png"
import piecePlaceholder6 from "@/images/pieces/placeholder5.png"
import moneyImage1 from "@/images/money/money1.png"
import moneyImage2 from "@/images/money/money2.png"
import moneyImage3 from "@/images/money/money3.png"
import moneyImage4 from "@/images/money/money4.png"
import moneyImage5 from "@/images/money/money5.png"
import moneyImage6 from "@/images/money/money6.png"
import moneyImage7 from "@/images/money/money7.png"
import houseImageSrc from "@/images/houses/house30.png"
import hotelImageSrc from "@/images/houses/house24.png"
import mainButtonBg from "@/images/main-btn-bg.webp"
import smallButtonBg from "@/images/small-btn-bg.webp"
import actionCardBack from "@/images/action-card-back.webp"
import eventCardBack from "@/images/event-card-back.webp"
import cellImage5 from "@/images/boards/default/cell5.webp"
import cellImage15 from "@/images/boards/default/cell15.webp"
import cellImage25 from "@/images/boards/default/cell25.webp"
import cellImage35 from "@/images/boards/default/cell35.webp"

import cardsIcon from "@/images/icons/cards.png"
import roleCard1 from "@/images/role-cards/role-image1.webp"
import roleCard2 from "@/images/role-cards/role-image2.webp"
import roleCard3 from "@/images/role-cards/role-image3.webp"
import roleCard4 from "@/images/role-cards/role-image4.webp"
import roleCard5 from "@/images/role-cards/role-image5.webp"
import roleCard6 from "@/images/role-cards/role-image6.webp"
import playerItemBg from "@/images/backgrounds/player-item.webp"
import auctionMan from "@/images/mr-monopoly/auction.png"
import auctionedIcon from "@/images/icons/auctioned.png"
import soldIcon from "@/images/icons/sold.png"
import auctionIcon from "@/images/icons/auction.png"
import mapImage1 from "@/images/map-images/map1.png"
import mapImage0 from "@/images/map-images/map0.png"
import stockIcon from "@/images/icons/stock.png"

import get10PercentFromAllPlayers from "@/images/cards/get-10-percent-from-all-players.webp"
import performTaxAudit from "@/images/cards/perform-tax-audit.webp"
import get100fromAnyPlayer from "@/images/cards/get-100-from-any-player.webp"
import get10percentfromAnyPlayer from "@/images/cards/get-10-percent-from-player.webp"
import getInterest from "@/images/cards/get-interest.webp"
import sayNo from "@/images/cards/say-no.webp"
import applyPropertyTax from "@/images/cards/apply-property-tax.webp"
import doubleRent from "@/images/cards/double-rent.webp"
import forcedAuction from "@/images/cards/forced-auction.webp"
import forcedBuy from "@/images/cards/forced-buy.webp"
import purchseAtDoublePrice from "@/images/cards/purchase-property-at-double-price.webp"
import useStockExchange from "@/images/cards/use-stock-exchange.webp"
import forcedDowngrade from "@/images/cards/forced-downgrade.webp"
import advanceToGo from "@/images/cards/advance-to-go.webp"
import getTwoMoreCards from "@/images/cards/get-two-more-cards.webp"
import swapPositionWithPlayer from "@/images/cards/swap-position-with-player.webp"
import applyHouseTax from "@/images/cards/apply-house-tax.webp"
import changeRoleForThreeTurns from "@/images/cards/change-role-for-three-turns.webp"
import decisionHubMiniMap1 from "@/images/boards/default/cell20-2.webp"
import decisionHubMiniMap2 from "@/images/boards/default/cell30-2.webp"

export const images = {
  houseImage: houseImageSrc,
  hotelImage: hotelImageSrc,
  auction: auctionMan,
  buttons: {
    mainButton: mainButtonBg,
    smallButton: smallButtonBg,
  },
  actionCardBack,
  eventCardBack,
  icons: {
    cards: cardsIcon,
    history: "/icons/history.png",
    auctioned: auctionedIcon,
    sold: soldIcon,
    auction: auctionIcon,
    stock: stockIcon,
  },
  roleCards: [roleCard1, roleCard2, roleCard3, roleCard4, roleCard5, roleCard6],
  roles: [],
  playerItemBg,
  maps: { "0": mapImage0, "1": mapImage1 },
  cards: {
    "get-10-percent-from-all-players": get10PercentFromAllPlayers,
    "perform-tax-audit": performTaxAudit,
    "get-10-percent-from-player": get10percentfromAnyPlayer,
    "get-200-from-player": get100fromAnyPlayer,
    "get-interest": getInterest,
    "say-no": sayNo,
    "apply-property-tax": applyPropertyTax,
    "dobule-rent": doubleRent,
    "forced-auction": forcedAuction,
    "forced-buy": forcedBuy,
    "purchase-any-property-for-double-price": purchseAtDoublePrice,
    "use-stock-exchange": useStockExchange,
    "force-downgrade-property": forcedDowngrade,
    "advance-to-go": advanceToGo,
    "get-two-more-cards": getTwoMoreCards,
    "swap-position-with-player": swapPositionWithPlayer,
    "apply-house-tax": applyHouseTax,
    "change-role-for-three-turns": changeRoleForThreeTurns,
  } as Record<ActionCardId, string>,
}

export const maps: IMap[] = [
  { name: "Standard", id: "0", limit: [3, 6] },
  { name: "Nested", id: "1", limit: [5, 8] },
  { name: "Small", id: "2", limit: [2, 4] },
]
export const allPieces: IPiece[] = [
  {
    id: "0",
    imgSrc: pieceImage1,
    placeholder: piecePlaceholder1,
    color: "#ba1bda",
  },
  {
    id: "1",
    imgSrc: pieceImage2,
    placeholder: piecePlaceholder2,
    color: "#137dbd",
  },
  {
    id: "2",
    imgSrc: pieceImage3,
    placeholder: piecePlaceholder3,
    color: "red",
  },
  {
    id: "3",
    imgSrc: pieceImage4,
    placeholder: piecePlaceholder4,
    color: "#53de17",
  },
  // Colours taken from the tokens themselves. They matter more now that any
  // player can pick any piece: the game log tints each name with its piece
  // colour, and these two used to fall back to plain grey.
  { id: "4", imgSrc: pieceImage5, placeholder: piecePlaceholder5, color: "#f0a500" },
  { id: "5", imgSrc: pieceImage6, placeholder: piecePlaceholder6, color: "#e2571e" },
]
const cornerCellSize = 125
const totalSizeX = 900
const totalSizeY = 900

export const minBidDifference = 10

const normalCellSize = (totalSizeX - 250) / 9
export interface ICellImage {
  order: number
  image?: string
  background?: string
  maxHeight?: number
  maxWidth?: number
  smallCardImage?: string
  bigCardImage?: string
}
export interface IMapImageData {
  mapId: string
  cellImages: ICellImage[]
}
export interface IMoneyAnimationItem {
  image: string
  value: number
}
export const moneyAnimationItems: IMoneyAnimationItem[] = [
  { image: moneyImage1, value: 1 },
  { image: moneyImage2, value: 5 },
  { image: moneyImage3, value: 10 },
  { image: moneyImage4, value: 20 },
  { image: moneyImage5, value: 50 },
  { image: moneyImage6, value: 100 },
  { image: moneyImage7, value: 500 },
]
export const allMapsImageData: IMapImageData[] = [
  {
    mapId: "0",
    cellImages: [
      { order: 0, background: cellImgae0 },
      // { order: 21, image: chanceImage1 },
      { order: 4, image: cellImage4, maxHeight: 15 },
      { order: 5, image: cellImage5 },
      { order: 15, image: cellImage15 },
      { order: 25, image: cellImage25 },
      { order: 35, image: cellImage35 },
      { order: 7, image: chanceImage1 },
      { order: 10, image: cellImage10 },
      {
        order: 12,
        image: chanceImage2,
      },
      { order: 17, image: chanceImage2 },
      // { order: 15, image: cellImage15, smallCardImage: smallCardImage5 },
      { order: 20, image: cellImage20 },
      { order: 22, image: chanceImage3 },
      // { order: 25, image: cellImage5, smallCardImage: smallCardImage5 },
      {
        order: 28,
        image: chanceImage3,
      },
      { order: 30, image: cellImage30 },
      { order: 33, image: chanceImage4 },
      // { order: 35, image: cellImage15, smallCardImage: smallCardImage5 },
      { order: 38, image: chanceImage4 },
    ],
  },
  {
    mapId: "1",
    cellImages: [
      { order: 0, background: cellImgae0 },
      { order: 3, image: cellImage4, maxHeight: 15 },
      { order: 4, image: cellImage5 },
      { order: 12, image: cellImage15 },
      { order: 20, image: cellImage25 },
      { order: 28, image: cellImage35 },
      { order: 6, image: chanceImage1 },
      { order: 8, image: decisionHubMiniMap1 },
      {
        order: 10,
        image: chanceImage2,
      },
      { order: 14, image: chanceImage2 },
      { order: 16, image: cellImage20 },
      { order: 18, image: chanceImage3 },
      { order: 22, image: chanceImage3 },
      { order: 24, image: decisionHubMiniMap2 },
      {
        order: 26,
        image: chanceImage4,
      },
      { order: 30, image: chanceImage4 },
    ],
  },
]

export const dummyUsers: IUser[] = [
  {
    username: "user1",
    password: "$2b$10$0n2fl9ZOft2C0i/hkCITSeY2p945q.BP85v2fYIQ154/yqM21g2Hq",
    email: "maheerali121@gmail.com",
    isVerified: true,
    otpTries: 0,
    resentOtpTimes: 0,
    allowedToResetPass: false,
    otp: "$2b$10$hV034rFdaVmGzWAdvs6VAOrSMAPqhoTKtm1tJAeGGp1NrOc0SVFBa",
  },

  {
    username: "user2",
    password: "$2b$10$0n2fl9ZOft2C0i/hkCITSeY2p945q.BP85v2fYIQ154/yqM21g2Hq",
    email: "maheerali131@gmail.com",
    isVerified: true,
    otpTries: 0,
    resentOtpTimes: 0,
    allowedToResetPass: false,
    otp: "$2b$10$hV034rFdaVmGzWAdvs6VAOrSMAPqhoTKtm1tJAeGGp1NrOc0SVFBa",
  },
  {
    username: "user4",
    password: "$2b$10$0n2fl9ZOft2C0i/hkCITSeY2p945q.BP85v2fYIQ154/yqM21g2Hq",
    email: "maheerali161@gmail.com",
    isVerified: true,
    otpTries: 0,
    resentOtpTimes: 0,
    allowedToResetPass: false,
    otp: "$2b$10$hV034rFdaVmGzWAdvs6VAOrSMAPqhoTKtm1tJAeGGp1NrOc0SVFBa",
  },
  {
    username: "user5",
    password: "$2b$10$0n2fl9ZOft2C0i/hkCITSeY2p945q.BP85v2fYIQ154/yqM21g2Hq",
    email: "maheerali171@gmail.com",
    isVerified: true,
    otpTries: 0,
    resentOtpTimes: 0,
    allowedToResetPass: false,
    otp: "$2b$10$hV034rFdaVmGzWAdvs6VAOrSMAPqhoTKtm1tJAeGGp1NrOc0SVFBa",
  },
  {
    username: "user6",
    password: "$2b$10$0n2fl9ZOft2C0i/hkCITSeY2p945q.BP85v2fYIQ154/yqM21g2Hq",
    email: "maheerali181@gmail.com",
    isVerified: true,
    otpTries: 0,
    resentOtpTimes: 0,
    allowedToResetPass: false,
    otp: "$2b$10$hV034rFdaVmGzWAdvs6VAOrSMAPqhoTKtm1tJAeGGp1NrOc0SVFBa",
  },
]
export const dummyPlayers: IPlayer[] = [
  {
    inJail: false,
    rollHistory: [[2, 3]],
    id: "maheerali121@gmail.com",
    eliminated: false,
    money: 1000,
    order: 0,
    pieceId: "0",
    position: 5,
    properties: [],
    inJailTurns: 0,
    jailFreeCards: [],
    positionAfterAnimation: 5,
    isBankrupt: false,
  },
  {
    inJail: false,
    rollHistory: [[2, 3]],
    id: "maheerali131@gmail.com",
    eliminated: false,
    money: 1000,
    order: 1,
    pieceId: "1",
    position: 5,
    properties: [],
    inJailTurns: 0,
    jailFreeCards: [],
    positionAfterAnimation: 5,
    isBankrupt: false,
  },
  {
    inJail: false,
    rollHistory: [[2, 3]],
    id: "maheerali161@gmail.com",
    eliminated: false,
    money: 1000,
    order: 2,
    pieceId: "2",
    position: 5,
    properties: [],
    inJailTurns: 0,
    jailFreeCards: [],
    positionAfterAnimation: 5,
    isBankrupt: false,
  },
  {
    inJail: false,
    rollHistory: [[2, 3]],
    id: "maheerali171@gmail.com",
    eliminated: false,
    money: 1000,
    order: 3,
    pieceId: "3",
    position: 5,
    properties: [],
    inJailTurns: 0,
    jailFreeCards: [],
    positionAfterAnimation: 5,
    isBankrupt: false,
  },
  {
    inJail: false,
    isBankrupt: false,
    rollHistory: [[2, 3]],
    id: "maheerali181@gmail.com",
    eliminated: false,
    money: 1000,
    order: 4,
    pieceId: "4",
    position: 5,
    properties: [],
    inJailTurns: 0,
    jailFreeCards: [],
    positionAfterAnimation: 5,
  },
]
export const bankOrder = 100

export const allColors = {
  buttonBaseColors: {
    green: "#44813b",
    red: "#783c3c",
    yellow: "#ab8b31",
    blue: "#3b4d81",
  },
}
